import React from "react";

import { Box, useTheme, Typography } from "@mui/material";

import icn_good from 'assets/images/icons/icn_table_cell_Verified_green.svg';
import icn_warning from 'assets/images/icons/icn_table_cell_Status_Warning.svg';
import icn_critical from 'assets/images/icons/icn_table_cell_Status_Critical.svg';

const IconTag = ({ width, label }) => {
  const theme = useTheme();

  const labelConfigMap = {
    Good: {
      color: "green",
      icon: icn_good,
    },
    Warning: {
      color: "orange",
      icon: icn_warning,
    },
    Critical: {
      color: "red",
      icon: icn_critical,
    },
  };

  const config = labelConfigMap[label] || {};

  const getBackgroundColor = (colorKey) => {
    switch (colorKey) {
      case "green":
        return theme.palette.primary.greenSixth;
      case "red":
        return theme.palette.primary.redFourth;
      case "orange":
        return theme.palette.primary.orangeFourth;
      default:
        return theme.palette.primary.greyPrimary;
    }
  };

  const getTypographyColor = (colorKey) => {
    switch (colorKey) {
      case "green":
        return theme.palette.primary.greenFifth;
      case "red":
        return theme.palette.primary.redPrimary;
      case "orange":
        return theme.palette.primary.orangeThird;
      default:
        return theme.palette.primary.greyPrimary;
    }
  };

  const backgroundColor = getBackgroundColor(config.color);
  const typographyColor = getTypographyColor(config.color);

  return (
    <Box
      sx={{
        width,
        backgroundColor: backgroundColor,
        height: "28px",
        borderRadius: theme.shape.customBorderRadius[0],
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1px",
        padding: "4px 8px 4px 5px",
      }}
    >
      {config.icon && (
        <img
          src={config.icon}
          alt={label}
          style={{ width: 20, height: 20 }}
        />
      )}
      <Typography
        sx={{
          color: typographyColor,
          lineHeight: 1.7,
          fontWeight: theme.typography.customFontWeight[2],
          fontSize: theme.typography.customFontSize[9],
        }}
      >
        {label || "-"}
      </Typography>
    </Box>
  );
};

export default IconTag;
